
import Modal from "../../Modal"
import WarningIcon from '../../../images/warning-icon.svg'
import { Button } from '@mui/material'
import styles from './Screener.module.scss'

const DeleteScreenerModal = ({open, uuid, name, handleClose, handleDeleteScreener}) => {

    const handleDelete = () => {
        handleDeleteScreener(uuid)
        handleClose()
    }
    
    return (
        <Modal open={open} handleClose={handleClose} elevation={1}>
            <div className={styles['delete-modal-content']}>
                <img src={WarningIcon} alt='warning-icon'/>
                <h2>Delete {name}?</h2>
                <div>
                    <Button onClick={handleClose}>cancel</Button>
                    <Button onClick={handleDelete} variant='contained' color="primary">Yes, I’m sure</Button>
                </div>
            </div>
        </Modal>
    )
}

export default DeleteScreenerModal